/**
 * Align mega-menu overlay with the real header bottom, including the
 * Loyalty Spotlight CTA section that sits above the sticky header.
 * Do not hardcode --header-height (e.g. 160px) — it breaks sticky math on resize.
 */
(function () {
  var overlayVar = '--mega-menu-overlay-offset';
  var spotlightVar = '--loyalty-spotlight-cta-height';
  var scrollHandler = null;

  function getSpotlightSection() {
    return document.querySelector('.shopify-section--apps:has(.yotpo-widget-spotlight-cta)');
  }

  function getHeaderSection() {
    return document.querySelector('.shopify-section--header');
  }

  function syncSpotlightHeight() {
    var section = getSpotlightSection();
    var height = section ? Math.round(section.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty(spotlightVar, height + 'px');
  }

  function syncOverlayOffset() {
    var header = getHeaderSection();
    if (!header) return;
    document.documentElement.style.setProperty(
      overlayVar,
      Math.round(header.getBoundingClientRect().bottom) + 'px'
    );
  }

  function clearOverlayOffset() {
    document.documentElement.style.removeProperty(overlayVar);
  }

  function isMegaMenu(target) {
    return target instanceof Element && target.classList.contains('mega-menu');
  }

  function stopScrollSync() {
    if (!scrollHandler) return;
    window.removeEventListener('scroll', scrollHandler);
    scrollHandler = null;
  }

  function startScrollSync(menu) {
    stopScrollSync();
    scrollHandler = syncOverlayOffset;
    window.addEventListener('scroll', scrollHandler, { passive: true });
    menu.addEventListener(
      'dialog:before-hide',
      function () {
        stopScrollSync();
        clearOverlayOffset();
      },
      { once: true }
    );
  }

  document.addEventListener(
    'dialog:before-show',
    function (event) {
      if (!isMegaMenu(event.target)) return;
      syncSpotlightHeight();
      syncOverlayOffset();
    },
    true
  );

  document.addEventListener(
    'dialog:after-show',
    function (event) {
      if (!isMegaMenu(event.target)) return;
      syncOverlayOffset();
      startScrollSync(event.target);
    },
    true
  );

  function init() {
    syncSpotlightHeight();

    var section = getSpotlightSection();
    if (section && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(syncSpotlightHeight).observe(section);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', syncSpotlightHeight, { passive: true });
})();
